// extracted by mini-css-extract-plugin
export default {"PrivacyPolicyPage":"PrivacyPolicy_PrivacyPolicyPage__pLMwX","ppcontainer":"PrivacyPolicy_ppcontainer__XG1mH"};